<template>
  <div class="container-fluid p-3">
    <barra-navegacao :visiblebutton="true"/>

    <!-- LISTAGEM -->
    <div v-if="!visualizando">
      <b-row class="text-center">
        <b-col cols="12">
          <div style="margin-bottom:10px"></div>
          <b-col lg="12" class="my-1">
            <b-form-group
              label="Pesquisar"
              label-for="filter-solicitacao"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-solicitacao"
                  v-model="filter"
                  type="search"
                  placeholder="Busca por ID, Descricao, Periodo..."
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <div style="margin: 10px"></div>
          <b-card bg-variant="light" body-class="p-1 p-md-3" style="min-height: 60vh;">
              <div class="overflow-auto">
                <b-table stacked="md"
                  id="table-solicitacoes"
                  @filtered="onFiltered"
                  :filter="filter"
                  striped small
                  :fields="fields"
                  :items="solicitacoes"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                >
                  <template v-slot:cell(status)="data">
                    <b-badge :variant="getBadgeVariant(data.item.status)">{{ mapStatus(data.item.status) }}</b-badge>
                  </template>
                  <template v-slot:cell(autorizado)="data">
                    <b-badge :variant="data.item.autorizado === null ? 'secondary' : (data.item.autorizado ? 'success' : 'danger')">
                      {{ data.item.autorizado === null ? 'Aguardando' : (data.item.autorizado ? 'Sim' : 'Nao') }}
                    </b-badge>
                  </template>
                  <template v-slot:cell(dataCriacao)="data">
                    {{ formatarData(data.item.dataCriacao) }}
                  </template>
                  <template v-slot:cell(acoes)="data">
                    <div class="d-flex align-items-center justify-content-center flex-nowrap">
                      <b-button @click="visualizar(data.item)" size="sm" style="background-color: #303f9f; margin-right: 5px" title="Visualizar" :id="`btn-ver-${data.item.idSolicitacao}`">
                      <b-icon icon="eye"></b-icon>
                    </b-button>
                    <b-button
                      @click="confirmarFinalizacao(data.item)"
                      size="sm"
                      style="background-color: #ffc107; margin-right: 5px;"
                      :title="!data.item.podeFinalizar ? `Todos os ${tipoSolicitacao === 'INVENTARIO' ? 'inventários' : 'checklists'} devem estar finalizados ou cancelados.` : 'Finalizar'"
                      :id="`btn-finalizar-${data.item.idSolicitacao}`"
                      :disabled="!data.item.podeFinalizar || data.item.status === 'Can' || data.item.status === 'Fin' || !ehAdminOuSupervisor"
                    >
                      <b-icon icon="flag-fill"></b-icon>
                    </b-button>
                    <b-button
                      v-if="false"
                      @click="confirmarCancelamento(data.item)"
                      size="sm"
                      style="background-color: #dc3545;"
                      title="Cancelar"
                      :id="`btn-cancelar-${data.item.idSolicitacao}`"
                      :disabled="data.item.status === 'Can' || data.item.status === 'Fin' || !ehAdminOuSupervisor"
                    >
                      <b-icon icon="x-circle"></b-icon>
                    </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="mt-3 d-flex justify-content-end">
                  <b-pagination
                    size="sm"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="table-solicitacoes"
                  ></b-pagination>
              </div>
            </b-card>
            <br>
            <b-card bg-variant="light">
              <div class="row" style="float: right">
                  <b-button @click="irParaNovaSolicitacao" id="btn-nova-solicitacao" style="margin-right: 30px; background-color: #303f9f" size="sm">
                    <b-icon icon="file-earmark"></b-icon> Nova Solicitação
                  </b-button>   
              </div>
            </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- VISUALIZACAO DETALHADA -->
    <div v-else-if="visualizando && solicitacaoSelecionada">
      <b-card bg-variant="light" style="box-shadow: 2px 2px 5px rgba(0,0,0,0.1);">
        <!-- Dados da Solicitação -->
        <b-row class="mb-3">
          <b-col md="2"><strong>ID:</strong> {{ solicitacaoSelecionada.solicitacao.idSolicitacao }}</b-col>
          <b-col md="3"><strong>Período:</strong> {{ solicitacaoSelecionada.solicitacao.periodoLetivo || '-' }}</b-col>
          <b-col md="2">
            <strong>Status:</strong>
            <b-badge :variant="getBadgeVariant(solicitacaoSelecionada.solicitacao.status)" class="ml-1">
              {{ mapStatus(solicitacaoSelecionada.solicitacao.status) }}
            </b-badge>
          </b-col>
          <b-col md="2">
            <strong>Autorizado:</strong>
            <b-badge :variant="solicitacaoSelecionada.solicitacao.autorizado === null ? 'secondary' : (solicitacaoSelecionada.solicitacao.autorizado ? 'success' : 'danger')" class="ml-1">
              {{ solicitacaoSelecionada.solicitacao.autorizado === null ? 'Aguardando' : (solicitacaoSelecionada.solicitacao.autorizado ? 'Sim' : 'Não') }}
            </b-badge>
          </b-col>
          <b-col md="3"><strong>Data:</strong> {{ formatarData(solicitacaoSelecionada.solicitacao.dataCriacao) }}</b-col>
        </b-row>
        <b-row class="mb-3" v-if="solicitacaoSelecionada.solicitacao.descricao">
          <b-col md="12"><strong>Descrição:</strong> {{ solicitacaoSelecionada.solicitacao.descricao }}</b-col>
        </b-row>

        <hr>

        <!-- Checklists Vinculados -->
        <h5 class="mb-3"><b-icon icon="card-checklist" class="mr-2"></b-icon>{{ tipoSolicitacao === 'INVENTARIO' ? 'Inventários Vinculados' : 'Checklists Vinculados' }}</h5>
        <div v-if="!solicitacaoSelecionada.checklists || solicitacaoSelecionada.checklists.length === 0" class="text-center text-muted py-3">
          Nenhum registro vinculado a esta solicitação.
        </div>
        <b-table stacked="md"
          v-else
          :items="solicitacaoSelecionada.checklists"
          :fields="fieldsChecklists"
          striped small responsive
          id="tabela-checklists-vinculados"
        >
          <template v-slot:cell(local)="data">
            {{ formatarLocal(data.item) }}
          </template>
          <template v-slot:cell(status)="data">
            <b-badge :variant="getBadgeVariant(data.item.status)">{{ mapStatus(data.item.status) }}</b-badge>
          </template>
          <template v-slot:cell(autorizado)="data">
            <b-badge :variant="data.item.autorizado === null ? 'secondary' : (data.item.autorizado ? 'success' : 'danger')">
              {{ data.item.autorizado === null ? 'Aguardando' : (data.item.autorizado ? 'Sim' : 'Nao') }}
            </b-badge>
          </template>
          <template v-slot:cell(ancora)="data">
            <span>{{ data.item.ancora ? 'Sim' : 'Nao' }}</span>
          </template>
          <template v-slot:cell(ocorrencias)="data">
            <div v-if="temOcorrencia(data.item.idCheckList)">
              <b-button size="sm" :variant="temOcorrenciaNaoFinalizada(data.item.idCheckList) ? 'danger' : 'primary'" @click="irParaOcorrencias(data.item.idCheckList)" title="Ver Ocorrências">Ver</b-button>
            </div>
            <div v-else>
              <b-button size="sm" variant="outline-secondary" disabled title="Nenhuma Ocorrência">Ver</b-button>
            </div>
          </template>
          <template v-slot:cell(acoes)="data">
            <b-button
              v-if="ehAdminOuSupervisor"
              size="sm"
              style="background-color: #28a745; margin-right: 4px"
              :title="tipoSolicitacao === 'INVENTARIO' ? 'Autorizar Inventário' : 'Autorizar Checklist'"
              :id="`btn-autorizar-cl-${data.item.idCheckList}`"
              @click="autorizarChecklistIndividually(data.item)"
              :disabled="data.item.autorizado || data.item.status === 'Can'"
            >
              <b-icon icon="check-circle"></b-icon>
            </b-button>
            <b-button
              size="sm"
              style="background-color: #303f9f; margin-right: 4px"
              :title="tipoSolicitacao === 'INVENTARIO' ? 'Visualizar Inventário' : 'Visualizar Checklist'"
              :id="`btn-ver-cl-${data.item.idCheckList}`"
              @click="visualizarChecklist(data.item)"
            >
              <b-icon icon="eye"></b-icon>
            </b-button>
            <b-button
              v-if="ehAdminOuSupervisor"
              size="sm"
              style="background-color: #dc3545;"
              :title="tipoSolicitacao === 'INVENTARIO' ? 'Cancelar Inventário' : 'Cancelar Checklist'"
              :id="`btn-cancelar-cl-${data.item.idCheckList}`"
              @click="confirmarCancelamentoChecklist(data.item)"
              :disabled="data.item.status === 'Can' || data.item.status === 'Fin'"
            >
              <b-icon icon="x-circle"></b-icon>
            </b-button>
          </template>
        </b-table>

        <hr>

        <!-- Botoes de Acao -->
        <div class="d-flex justify-content-end align-items-center flex-wrap" style="gap: 8px;">
          <div v-if="ehAdminOuSupervisor" class="d-flex" style="gap: 8px;">
            <b-button
              variant="primary"
              @click="adicionarNovoChecklist"
             size="sm"
             :disabled="solicitacaoSelecionada.solicitacao.status === 'Can' || solicitacaoSelecionada.solicitacao.status === 'Fin'">
              <b-icon icon="plus-circle"></b-icon> {{ tipoSolicitacao === 'INVENTARIO' ? 'Adicionar Inventário' : 'Adicionar Checklist' }}
            </b-button>
            <b-button
              variant="success"
              @click="autorizarSolicitacao(true)"
              id="btn-autorizar"
             size="sm"
             :disabled="solicitacaoSelecionada.solicitacao.autorizado !== null">
              <b-icon icon="check-circle"></b-icon> Autorizar Todos
            </b-button>
            <b-button
              variant="danger"
              @click="autorizarSolicitacao(false)"
              id="btn-recusar"
             size="sm"
             :disabled="solicitacaoSelecionada.solicitacao.autorizado !== null">
              <b-icon icon="x-circle"></b-icon> Recusar Todos
            </b-button>
            <b-button
              variant="warning"
              @click="finalizarSolicitacao"
              id="btn-finalizar"
              :disabled="!podeFinalizarDetalhe || solicitacaoSelecionada.solicitacao.status === 'Can' || solicitacaoSelecionada.solicitacao.status === 'Fin'"
              :title="!podeFinalizarDetalhe ? `Todos os ${tipoSolicitacao === 'INVENTARIO' ? 'inventários' : 'checklists'} devem estar finalizados ou cancelados.` : ''"
            >
              <b-icon icon="flag-fill"></b-icon> Finalizar
            </b-button>
            <b-button
              v-if="false"
              variant="danger"
              @click="confirmarCancelamento(solicitacaoSelecionada.solicitacao)"
              id="btn-cancelar"
              :disabled="solicitacaoSelecionada.solicitacao.status === 'Can' || solicitacaoSelecionada.solicitacao.status === 'Fin'"
            >
              <b-icon icon="x-octagon"></b-icon> Cancelar
            </b-button>
          </div>
        </div>
      </b-card>
    </div>

  </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';
import SolicitacaoService from '../../services/SolicitacaoService';
import ChecklistService from '../../services/ChecklistService';
import OcorrenciaService from '../../services/OcorrenciaService';
import { PerfilService } from '@/services/PerfilService';

export default {
  name: 'ListagemSolicitacao',
  components: { BarraNavegacao },
  data() {
    return {
      ehAdminOuSupervisor: false,
      tipoSolicitacao: 'INVENTARIO',
      solicitacoes: [],
      solicitacaoSelecionada: null,
      ocorrenciasAtivas: [],

      filter: null,
      perPage: 15,
      currentPage: 1,
      rows: 0,

      fields: [
        { key: 'idSolicitacao', label: 'ID', sortable: true },
        { key: 'periodoLetivo', label: 'Periodo', sortable: true },
        { key: 'descricao', label: 'Descricao', sortable: true },
        { key: 'dataCriacao', label: 'Data', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'autorizado', label: 'Autorizado', sortable: true },
        { key: 'acoes', label: 'Acoes', class: 'text-center' }
      ],

      fieldsChecklists: [
        { key: 'idCheckList', label: 'ID' },
        { key: 'local', label: 'Local' },
        { key: 'status', label: 'Status', class: 'text-center' },
        { key: 'autorizado', label: 'Autorizado', class: 'text-center' },
        { key: 'ancora', label: 'Invetário', class: 'text-center' },
        { key: 'ocorrencias', label: 'Ocorrências', class: 'text-center' },
        { key: 'acoes', label: 'Ações', class: 'text-center' }
      ]
    };
  },
  computed: {
    visualizando() {
      return !!this.$route.query.id;
    },
    podeFinalizarDetalhe() {
      if (!this.solicitacaoSelecionada || !this.solicitacaoSelecionada.checklists) return false;
      const chks = this.solicitacaoSelecionada.checklists;
      if (chks.length === 0) return false;
      return chks.every(c => c.status === 'Fin' || c.status === 'Can');
    }
  },
  watch: {
    $route(to) {
      if (to.meta && to.meta.tipo) {
        this.tipoSolicitacao = to.meta.tipo;
        this.listarSolicitacoes();
      }
    }
  },
  created() {
    const idParam = this.$route.query.id;
    if (idParam && !this.solicitacaoSelecionada) {
      this.$loading(true);
      SolicitacaoService.buscarPorId(idParam).then(res => {
        this.solicitacaoSelecionada = res.data;
      }).catch(() => {
        this.$router.replace({ query: {} }).catch(() => {});
      }).finally(() => {
        this.$loading(false);
      });
    }
    if (this.$route.meta && this.$route.meta.tipo) {
      this.tipoSolicitacao = this.$route.meta.tipo;
    }
    const perfilService = new PerfilService();
    this.ehAdminOuSupervisor = perfilService.ehAdminOuSupervisor;
    if (!this.ehAdminOuSupervisor) {
      this.fieldsChecklists = this.fieldsChecklists.filter(f => f.key !== 'ocorrencias');
    }
    this.carregarOcorrencias();
    this.listarSolicitacoes();
  },
  methods: {
    carregarOcorrencias() {
      OcorrenciaService.buscarOcorrenciasChecklist().then(resOcor => {
        let dados = resOcor.data;
        if (typeof dados === 'string') {
          try { dados = JSON.parse(dados); } catch(e) { dados = []; }
        }
        this.ocorrenciasAtivas = Array.isArray(dados) ? dados : [];
      }).catch(e => console.error("Erro ao buscar ocorrências", e));
    },

    alertaMensager(mensagem, titulo, tipo) {
      this.$fire({ title: titulo, text: mensagem, type: tipo });
    },

    formatarData(data) {
      if (!data) return '-';
      return new Date(data).toLocaleDateString('pt-BR');
    },

    formatarLocal(item) {
      if (!item) return '';
      let partes = [];
      if (item.bloco && item.bloco.descricao) partes.push(item.bloco.descricao);
      if (item.andar && item.andar.descricao) partes.push(item.andar.descricao);
      if (item.corredor && item.corredor.descricao) partes.push(item.corredor.descricao);
      if (item.sala && item.sala.descricaoCompleta) partes.push(item.sala.descricaoCompleta);
      return partes.length > 0 ? partes.join(' - ') : 'Nao informado';
    },

    getBadgeVariant(status) {
      const map = { Pen: 'warning', Ini: 'info', Fin: 'success', Can: 'danger' };
      return map[status] || 'secondary';
    },

    mapStatus(status) {
      const map = { Pen: 'Pendente', Ini: 'Iniciada', Fin: 'Finalizada', Can: 'Cancelada' };
      return map[status] || status;
    },

    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },

    listarSolicitacoes() {
      this.$loading(true);
      SolicitacaoService.listarTodos().then(res => {
        // Mostra as do tipo correto OU as que não tem tipo (antigas, para o usuário arrumar)
        this.solicitacoes = res.data.filter(s => s.tipo === this.tipoSolicitacao || !s.tipo);
        this.solicitacoes.sort((a, b) => b.idSolicitacao - a.idSolicitacao);
        this.rows = this.solicitacoes.length;
      }).catch(err => {
        console.error(err);
        this.alertaMensager('Erro ao listar solicitacoes.', 'Erro', 'error');
      }).finally(() => {
        this.$loading(false);
      });
    },

    visualizar(solicitacao) {
      this.$loading(true);
      SolicitacaoService.buscarPorId(solicitacao.idSolicitacao).then(res => {
        this.solicitacaoSelecionada = res.data;
        this.$router.push({ query: { id: solicitacao.idSolicitacao } }).catch(() => {});
      }).catch(err => {
        console.error(err);
        this.alertaMensager('Erro ao carregar detalhes.', 'Erro', 'error');
      }).finally(() => {
        this.$loading(false);
      });
    },

    fecharVisualizacao() {
      this.solicitacaoSelecionada = null;
      this.$router.push({ query: {} }).catch(() => {});
      this.listarSolicitacoes();
    },

    irParaNovaSolicitacao() {
      const rota = this.tipoSolicitacao === 'INVENTARIO' ? '/solicitacao/inventario/nova' : '/solicitacao/checklist/nova';
      this.$router.push(rota).catch(()=>{});
    },

    adicionarNovoChecklist() {
      const rota = this.tipoSolicitacao === 'INVENTARIO' ? '/solicitacao/inventario/nova' : '/solicitacao/checklist/nova';
      this.$router.push({ 
        path: rota, 
        query: { id: this.solicitacaoSelecionada.solicitacao.idSolicitacao } 
      });
    },

    autorizarSolicitacao(autorizado) {
      const textoItem = this.tipoSolicitacao === 'INVENTARIO' ? 'inventários' : 'checklists';
      const mensagem = autorizado
        ? `Deseja autorizar todos os ${textoItem} desta solicitacao?`
        : `Deseja RECUSAR todos os ${textoItem} desta solicitacao?`;
      this.$bvModal.msgBoxConfirm(mensagem, {
        title: autorizado ? 'Confirmar Autorizacao' : 'Confirmar Recusa',
        okVariant: autorizado ? 'success' : 'danger',
        okTitle: autorizado ? 'Autorizar' : 'Recusar',
        cancelTitle: 'Cancelar',
        centered: true
      }).then(value => {
        if (!value) return;
        this.$loading(true);
        SolicitacaoService.autorizar(this.solicitacaoSelecionada.solicitacao.idSolicitacao, autorizado).then(() => {
          this.$bvToast.toast(autorizado ? 'Solicitacao autorizada!' : 'Solicitacao recusada.', {
            variant: autorizado ? 'success' : 'danger', solid: true, autoHideDelay: 3000, title: 'Atualizado'
          });
          this.visualizar(this.solicitacaoSelecionada.solicitacao);
        }).catch(() => {
          this.alertaMensager('Erro ao processar autorizacao.', 'Erro', 'error');
          this.$loading(false);
        });
      });
    },

    finalizarSolicitacao() {
      this.confirmarFinalizacao(this.solicitacaoSelecionada.solicitacao);
    },

    confirmarFinalizacao(solicitacao) {
      const textoItem = this.tipoSolicitacao === 'INVENTARIO' ? 'inventários' : 'checklists';
      this.$bvModal.msgBoxConfirm(`Deseja finalizar esta solicitacao? Todos os ${textoItem} devem estar finalizados ou cancelados. (Se todos estiverem cancelados, a solicitacao sera cancelada)`, {
        title: 'Confirmar Finalizacao',
        okVariant: 'warning',
        okTitle: 'Finalizar',
        cancelTitle: 'Cancelar',
        centered: true
      }).then(value => {
        if (!value) return;
        this.$loading(true);
        SolicitacaoService.finalizar(solicitacao.idSolicitacao).then(() => {
          this.$bvToast.toast('Solicitacao finalizada com sucesso!', { variant: 'success', solid: true, autoHideDelay: 3000, title: 'Sucesso' });
          if (this.solicitacaoSelecionada && this.solicitacaoSelecionada.solicitacao.idSolicitacao === solicitacao.idSolicitacao) {
            this.visualizar(solicitacao);
          } else {
            this.listarSolicitacoes();
          }
        }).catch(err => {
          const msg = err.response && err.response.data ? err.response.data : 'Erro ao finalizar solicitacao.';
          this.alertaMensager(msg, 'Erro', 'error');
          this.$loading(false);
        });
      });
    },

    confirmarCancelamento(solicitacao) {
      const textoItem = this.tipoSolicitacao === 'INVENTARIO' ? 'inventários' : 'checklists';
      this.$bvModal.msgBoxConfirm(`Deseja cancelar esta solicitacao? Todos os ${textoItem} pendentes serao cancelados.`, {
        title: 'Confirmar Cancelamento',
        okVariant: 'danger',
        okTitle: 'Cancelar Solicitacao',
        cancelTitle: 'Voltar',
        centered: true
      }).then(value => {
        if (!value) return;
        this.$loading(true);
        SolicitacaoService.cancelar(solicitacao.idSolicitacao).then(() => {
          this.$bvToast.toast('Solicitacao cancelada.', { variant: 'info', solid: true, autoHideDelay: 3000, title: 'Cancelado' });
          if (this.solicitacaoSelecionada && this.solicitacaoSelecionada.solicitacao.idSolicitacao === solicitacao.idSolicitacao) {
            this.fecharVisualizacao();
          } else {
            this.listarSolicitacoes();
          }
        }).catch(() => {
          this.alertaMensager('Erro ao cancelar solicitacao.', 'Erro', 'error');
          this.$loading(false);
        });
      });   },

    visualizarChecklist(checklist) {
      const rota = this.tipoSolicitacao === 'INVENTARIO' ? '/inventario/lista' : '/checklist/lista';
      this.$router.push({ 
        path: rota, 
        query: { 
          id: checklist.idCheckList, 
          origem: 'solicitacao', 
          solicitacaoId: this.solicitacaoSelecionada.solicitacao.idSolicitacao,
          visualizando: 'true'
        } 
      }).catch(()=>{});
    },

    confirmarCancelamentoChecklist(checklist) {
      const textoItem = this.tipoSolicitacao === 'INVENTARIO' ? 'Inventário' : 'Checklist';
      this.$bvModal.msgBoxConfirm(`Deseja cancelar o ${textoItem.toLowerCase()} #${checklist.idCheckList}?`, {
        title: `Cancelar ${textoItem}`,
        okVariant: 'danger',
        okTitle: `Cancelar ${textoItem}`,
        cancelTitle: 'Voltar',
        centered: true
      }).then(value => {
        if (!value) return;
        this.$loading(true);
        this.$http.put(`/checklist/${checklist.idCheckList}/status`, { status: 'Can' }).then(() => {
          this.$bvToast.toast(`${textoItem} cancelado.`, { variant: 'info', solid: true, autoHideDelay: 3000, title: 'Cancelado' });
          // Recarrega os detalhes da solicitacao para atualizar a tabela
          this.visualizar(this.solicitacaoSelecionada.solicitacao);
        }).catch(() => {
          this.alertaMensager(`Erro ao cancelar ${textoItem.toLowerCase()}.`, 'Erro', 'error');
          this.$loading(false);
        });
      });
    },

    temOcorrencia(idCheckList) {
      if (!this.ocorrenciasAtivas) return false;
      return this.ocorrenciasAtivas.some(o => o.ocorrencia && o.ocorrencia.checkList && Number(o.ocorrencia.checkList.idCheckList) === Number(idCheckList));
    },

    irParaOcorrencias(idCheckList) {
      this.$router.push({ path: '/ocorrencia/gerenciar', query: { filtro: idCheckList } }).catch(()=>{});
    },

    temOcorrenciaNaoFinalizada(idCheckList) {
      if (!this.ocorrenciasAtivas) return false;
      const ocorrenciasDoLocal = this.ocorrenciasAtivas.filter(o => o.ocorrencia && o.ocorrencia.checkList && Number(o.ocorrencia.checkList.idCheckList) === Number(idCheckList));
      if (ocorrenciasDoLocal.length === 0) return false;
      return ocorrenciasDoLocal.some(o => {
         return !o.finalizado && o.statusChamadoGLPI !== 'Finalizado' && (!o.ocorrencia || o.ocorrencia.status !== 'Fin');
      });
    },

    autorizarChecklistIndividually(checklist) {
      this.$loading(true);
      const textoItem = this.tipoSolicitacao === 'INVENTARIO' ? 'Inventário' : 'Checklist';
      ChecklistService.autorizar(checklist.idCheckList).then(() => {
        this.alertaMensager(`${textoItem} autorizado com sucesso!`, "Sucesso", "success");
        // Recarrega os detalhes da solicitação
        this.visualizar(this.solicitacaoSelecionada.solicitacao);
      }).catch(err => {
        console.error(err);
        this.alertaMensager(`Erro ao autorizar ${textoItem.toLowerCase()}.`, "Erro", "error");
      }).finally(() => {
        this.$loading(false);
      });
    }
  }
};
</script>
